import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function BookingEmbed() {
  return <section className="py-16 bg-white" data-id="element-162">
      <div className="container mx-auto px-4 md:px-6" data-id="element-163">
        <div className="max-w-5xl mx-auto" data-id="element-164">
          <div className="text-center mb-10" data-id="element-165">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-166">
              Book Your Complimentary Luxury Retreat
            </h2>
            <p className="text-lg text-[#374047]/80 max-w-3xl mx-auto" data-id="element-167">
              Schedule a 30-minute discovery call with our team to discuss your
              eligibility for this exclusive paradise experience
            </p>
          </div>
          <div className="bg-[#F4E8D0]/30 rounded-xl p-6 md:p-8 shadow-sm" data-id="element-168">
            {/* Book Discovery Call Button */}
            <div className="bg-white rounded-xl shadow-sm p-12 text-center" data-id="element-169">
              <CalendarIcon className="h-16 w-16 text-[#0099A1] mx-auto mb-6" data-id="element-170" />
              <h3 className="text-2xl font-bold text-[#374047] mb-4" data-id="element-171">
                Ready to Experience Paradise?
              </h3>
              <p className="text-lg text-[#374047]/80 mb-8 max-w-2xl mx-auto" data-id="element-172">
                Book a discovery call to learn more about this exclusive
                opportunity and determine if you qualify for our complimentary
                luxury retreat.
              </p>
              <Button variant="primary" size="lg" href="https://calendly.com/ashsingh/destameet-discovery-call" data-id="element-173">
                Book a Discovery Call
              </Button>
            </div>
            {/* Additional information */}
            <div className="mt-8 grid md:grid-cols-3 gap-6 text-center" data-id="element-174">
              <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-175">
                <CalendarIcon className="h-8 w-8 text-[#0099A1] mx-auto mb-3" data-id="element-176" />
                <h3 className="font-bold text-[#374047] mb-2" data-id="element-177">
                  30-Minute Consultation
                </h3>
                <p className="text-sm text-[#374047]/70" data-id="element-178">
                  Discuss your organization's retreat objectives and eligibility
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-179">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#0099A1] mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-180">
                  <circle cx="12" cy="12" r="10" data-id="element-181"></circle>
                  <polyline points="12 6 12 12 16 14" data-id="element-182"></polyline>
                </svg>
                <h3 className="font-bold text-[#374047] mb-2" data-id="element-183">
                  Flexible Scheduling
                </h3>
                <p className="text-sm text-[#374047]/70" data-id="element-184">
                  Choose from available times that work best for you
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-185">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#0099A1] mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-186">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-187"></path>
                  <polyline points="22 4 12 14.01 9 11.01" data-id="element-188"></polyline>
                </svg>
                <h3 className="font-bold text-[#374047] mb-2" data-id="element-189">No Obligation</h3>
                <p className="text-sm text-[#374047]/70" data-id="element-190">
                  Learn about the program with zero pressure or commitment
                </p>
              </div>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-191">
            <p className="text-sm text-[#374047]/70 mb-4" data-id="element-192">
              Can't find a suitable time? Contact us directly
            </p>
            <Button variant="outline" href="mailto:experience@destameet.com" data-id="element-193">
              Email Our Team
            </Button>
          </div>
        </div>
      </div>
    </section>;
}